/**
 * AccessDenied: shared "you can't be here" panel (spec 020 PR #85 review,
 * F1). Authenticated users who lack the required grant see this instead of
 * a silent redirect — the markup is lifted verbatim from the pre-existing
 * denied block in AppAccessGuard.tsx so both call sites render one thing.
 */
import { useNavigate } from 'react-router-dom';

interface AccessDeniedProps {
  message?: string;
}

export function AccessDenied({ message = 'You do not have access to this app.' }: AccessDeniedProps) {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8">
      <h2 className="text-xl font-semibold text-destructive">Access Denied</h2>
      <p className="text-muted-foreground text-center">{message}</p>
      <button
        type="button"
        onClick={() => navigate('/', { replace: true })}
        className="text-sm font-medium text-primary underline"
      >
        Back to launcher
      </button>
    </div>
  );
}
